import type { RfpStatus, RfpVendorStatus, VendorType } from '../types/api';

export type BadgeVariant = 'info' | 'warning' | 'success' | 'orange' | 'neutral' | 'neutral-strong';

/**
 * Badge label + colour for every RFP status, matching the design:
 *   Draft            -> grey,   dark text
 *   Send to Vendors  -> amber
 *   In Progress      -> blue
 *   Respond Recieved -> green
 *   Closed           -> grey
 */
export const RFP_STATUS_META: Record<RfpStatus, { label: string; variant: BadgeVariant }> = {
  draft: { label: 'Draft', variant: 'neutral-strong' },
  send_to_vendors: { label: 'Send to Vendors', variant: 'warning' },
  in_progress: { label: 'In Progress', variant: 'info' },
  respond_received: { label: 'Respond Recieved', variant: 'success' },
  closed: { label: 'Closed', variant: 'neutral' },
};

export const VENDOR_TYPE_META: Record<VendorType, { label: string; variant: BadgeVariant }> = {
  new: { label: 'New', variant: 'orange' },
  existing: { label: 'Existing', variant: 'success' },
  past_contact: { label: 'Past Contact', variant: 'orange' },
};

export const RFP_VENDOR_STATUS_META: Record<
  RfpVendorStatus,
  { label: string; variant: BadgeVariant }
> = {
  pending: { label: 'Pending', variant: 'neutral' },
  contacted: { label: 'Contacted', variant: 'warning' },
  responded: { label: 'Response Recieved', variant: 'success' },
  submitted: { label: 'Submitted', variant: 'info' },
  completed: { label: 'Completed', variant: 'success' },
  declined: { label: 'Declined', variant: 'neutral' },
};

export function rfpStatusMeta(status: RfpStatus) {
  return RFP_STATUS_META[status] ?? { label: status, variant: 'neutral' as BadgeVariant };
}
